import { SelectOption } from 'types/common'
import { useMemo } from 'react'
import { zeroPadding } from 'lib/helper'

const useTimeOptions = (): SelectOption[] => {
  return useMemo(() => {
    const times: SelectOption[] = [{ label: '', value: '' }]
    // 15分毎で24時間分のリストを作る
    for (let i = 0; i < 24; i = (i + 1) | 0) {
      for (let j = 0; j < 60; j = (j + 15) | 0) {
        const time = `${zeroPadding(i)}:${zeroPadding(j)}`
        times.push({ label: time, value: time })
      }
    }
    // 23:45を選べないようにする
    times.pop()
    return times
  }, [])
}
export default useTimeOptions
